export var LayoutControlType;
(function (LayoutControlType) {
    LayoutControlType["Substructure"] = "Control:substructure";
    LayoutControlType["Edit"] = "Control:edit";
    LayoutControlType["Slider"] = "Control:slider";
    LayoutControlType["Thumbnail"] = "Control:thumbnail";
    LayoutControlType["Radios"] = "Control:radio";
    LayoutControlType["Select"] = "Control:select";
    LayoutControlType["Checkboxes"] = "Control:check";
    LayoutControlType["SingleCheckbox"] = "Control:check-single";
    /**
     * @deprecated Removed in favor of AttributeInfoText
     */
    LayoutControlType["Info"] = "Control:info";
    LayoutControlType["InfoValues"] = "Control:info-values";
    LayoutControlType["Individual"] = "Control:individual";
    LayoutControlType["Autocomplete"] = "Control:autocomplete";
    LayoutControlType["Datepicker"] = "Control:date";
    LayoutControlType["ColorPicker"] = "Control:color";
    LayoutControlType["Table"] = "Control:table";
})(LayoutControlType || (LayoutControlType = {}));
//# sourceMappingURL=LayoutControlType.js.map